import { ADD_CORROSION_LOG_FORM_FEILDS } from 'features/wells/corrosion/helpers/corrosionlogs.constants';

import { object, string, date } from 'yup';

export const getAddLogFileFormSchema = () =>
  object().shape({
    [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]: string()
      .required('File name is required')
      .nullable(),
    [ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]: date()
      .nullable()
      .typeError('Invalid date format')
      .required('Log date is required'),
    [ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER]: string().required(
      'Please select a Service Provider',
    ),
    [ADD_CORROSION_LOG_FORM_FEILDS.TOOL]: string().required(
      'Please select a Tool',
    ),
  });
